import React from 'react'
import styled from 'styled-components/macro'

const Wrapper = styled.div`
  margin-top: ${({ theme }) => `${theme.padding.xxl}`};
`

export const ButtonWrapper = ({ children }) => <Wrapper>{children}</Wrapper>
